import React from 'react'

interface RobinhoodBannerProps {
  className?: string
  descriptionContent?: React.ReactNode
  showViewDisclosures?: boolean
}

const RobinhoodBanner: React.FC<RobinhoodBannerProps> = ({
  className = '',
  descriptionContent = (
    <>
      Gold members enjoy mortgage rates below the national average—plus receive
      a {''}
      <span className="robinhood-banner__highlight">$500 credit</span> at
      closing.
    </>
  ),
  showViewDisclosures = false,
}) => {
  return (
    <>
      <style>
        {`@font-face {
          font-family:'Rh-phonic';
          src: url('/assets/RHPhonic-Medium.woff2') format('woff2');
          font-weight: 500;
          font-style: normal;
          font-display: swap;
        }`}
      </style>
      <div className={`robinhood-banner ${className}`}>
        <div className="robinhood-banner__content">
          <div className="robinhood-banner__title">
            Exclusive to{' '}
            <span className="robinhood-banner__gold">Robinhood Gold</span>{' '}
          </div>
          <div className="robinhood-banner__description">
            {descriptionContent}
            {showViewDisclosures && (
              <a
                className="robinhood-banner__learn-more"
                href="https://www.sagehomeloans.com/rh-disclosures"
                target="_blank"
                rel="noopener noreferrer"
              >
                View disclosures
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default RobinhoodBanner
